__turbopack_context__.v({
  "bestoffer_contact": "page-module-scss-module__z0Nshq__bestoffer_contact",
  "bestoffer_contact_agreement": "page-module-scss-module__z0Nshq__bestoffer_contact_agreement",
  "bestoffer_contact_badge": "page-module-scss-module__z0Nshq__bestoffer_contact_badge",
  "bestoffer_contact_bubble": "page-module-scss-module__z0Nshq__bestoffer_contact_bubble",
  "bestoffer_contact_card_step2": "page-module-scss-module__z0Nshq__bestoffer_contact_card_step2",
  "bestoffer_contact_caution": "page-module-scss-module__z0Nshq__bestoffer_contact_caution",
  "bestoffer_contact_content": "page-module-scss-module__z0Nshq__bestoffer_contact_content",
  "bestoffer_contact_heading": "page-module-scss-module__z0Nshq__bestoffer_contact_heading",
  "bestoffer_contact_hero": "page-module-scss-module__z0Nshq__bestoffer_contact_hero",
  "bestoffer_contact_is_step2": "page-module-scss-module__z0Nshq__bestoffer_contact_is_step2",
  "bestoffer_contact_notice": "page-module-scss-module__z0Nshq__bestoffer_contact_notice",
  "bestoffer_contact_step2_fields": "page-module-scss-module__z0Nshq__bestoffer_contact_step2_fields",
  "bestoffer_contact_title": "page-module-scss-module__z0Nshq__bestoffer_contact_title",
});
